import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import call from '../../../vendors/FormValidation/utils/call';

const NAME = 'Pagination';

class Pagination extends BaseComponent {
	constructor(element) {
		super(element);
		this.maxLinks = 7;
		this._data = {
			totalPages: 1,
			currentPage: 1
		};
		this._changeCallbacks = [];
		this.init();
	}

	set data(data) {
		this._data = data;
		this.render();
	}

	get data() {
		return this._data;
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this.render();
	}

	onChange(callback) {
		this._changeCallbacks.push(callback);
	}

	render() {
		const { totalPages, currentPage } = this.data;
		this.startIndex = currentPage > 3 ? currentPage - 2 : currentPage;
		this.endIndex = this.startIndex + this.maxLinks;

		const pageLinks = Array.from({ length: totalPages }).map((__, index) => this.renderPageLink(index, currentPage));

		if (currentPage + 2 < totalPages - 1) {
			const x = currentPage + 3;
			const count = totalPages - x - 1;
			pageLinks.splice(x, count, `<li class="ellipsis-pre" data-small="false"></li>`);
		}

		if (currentPage - 3 > 0) {
			const x = 1;
			const count = currentPage - 3;
			pageLinks.splice(x, count, `<li class="ellipsis-pre" data-small="false"></li>`);
		}

		const previousPage = currentPage - 1 > 0 ? currentPage - 1 : 0;
		const nextPage = currentPage + 1 < totalPages - 1 ? currentPage + 1 : totalPages - 1;

		this._element.innerHTML = `<div class="lta-pagination">
				<button class="lta-navigational-btn lta-navigational-btn--default" aria-label="previous page" title="previous page">
					<svg class="lta-icon js-lta-text-input--btn-icon lta-navigational-icon" width="1em" height="1em" fill="currentColor" alt="arrow-left-circle" aria-hidden="true" data-page="${previousPage}">
						<use xlink:href="/static/images/icons/lta-icons.svg#arrow-left-circle"></use>
					</svg>
				</button>
				<ol>
					${pageLinks.join('')}
				</ol>
				<button class="lta-navigational-btn lta-navigational-btn--default" aria-label="next page" title="next page">
					<svg class="lta-icon js-lta-text-input--btn-icon lta-navigational-icon" width="1em" height="1em" fill="currentColor" alt="arrow-right-circle" aria-hidden="true" data-page="${nextPage}">
						<use xlink:href="/static/images/icons/lta-icons.svg#arrow-right-circle"></use>
					</svg>
				</button>
			</div>`;
		this.afterRender();
	}

	renderPageLink(index, currentPage) {
		return `<li class="${currentPage === index ? 'active' : ''}" data-small="false">
					<a class="lta-pagination-${index} u-label1" data-page="${index}">${index + 1}</a>
				</li>`;
	}

	afterRender() {
		const pageLinkElements = SelectorEngine.find('li', this._element);
		for (const link of pageLinkElements) {
			EventHandler.on(link, 'click', this.pageClickHandler.bind(this));
		}
		// TODO - Bind event for previous and next.
		const buttons = SelectorEngine.find('.lta-navigational-btn', this._element);
		for (const button of buttons) {
			EventHandler.on(button, 'click', this.pageClickHandler.bind(this));
		}
	}

	pageClickHandler(event) {
		const { page } = Manipulator.getDataAttributes(event.target);
		for (const callback of this._changeCallbacks) {
			callback(page);
		}
	}
}

export default Pagination;
